import { connect } from 'react-redux'
import type { Dispatch } from 'redux'
import type { AppStateType } from '../../../reducers/appstate'
import SubscriptionName from './SubscriptionName'
import type { PropsType, DispatchPropsType } from './SubscriptionName'
import { addNameAction } from '../../../actions/subscriptionActions'

const mapStateToProps = (state: AppStateType, ownProps: { isPromo?: boolean }): PropsType => {
  return {
    isPromo: ownProps.isPromo,
    isNameError: !!state.subscriptionPurchase && !!state.subscriptionPurchase.error && !state.subscriptionPurchase.name
  } as PropsType
}

const mapDispatchToProps = (dispatch: Dispatch<any>): DispatchPropsType => {
  return {
    updateName: (name: string): void => { dispatch(addNameAction(name)) }
  } as DispatchPropsType
}

export default connect(mapStateToProps, mapDispatchToProps)(SubscriptionName)
